// extracted by mini-css-extract-plugin
module.exports = {"desktopCtasContainer":"DesktopCtas_desktopCtasContainer__HlpdB","floating":"DesktopCtas_floating__SAue1","floatingDark":"DesktopCtas_floatingDark__UIELc"};